import { Link } from 'react-router';
import { useLicenseStatus } from '../state/license';
import { daysUntil } from './ui';

/** Desktop only: warns when this computer's licenses can't be refreshed. */
export function LicenseBanner() {
  const status = useLicenseStatus();
  if (!status || !status.signedIn) return null;

  if (status.error?.code === 'device_limit') {
    return (
      <div className="container" style={{ marginTop: 16 }}>
        <div className="notice warning row between wrap">
          <span>This computer isn't activated: your account is already active on the maximum number of computers. Products run with the watermark here.</span>
          <Link className="btn btn-sm btn-outline" to="/account/devices">Manage devices</Link>
        </div>
      </div>
    );
  }
  if (status.error?.code === 'device_revoked') {
    return (
      <div className="container" style={{ marginTop: 16 }}>
        <div className="notice warning">This computer was blocked for your account. Contact support.</div>
      </div>
    );
  }
  const days = daysUntil(status.expiresAt);
  if (status.error && days != null && days <= 7) {
    return (
      <div className="container" style={{ marginTop: 16 }}>
        <div className="notice warning">
          We couldn't refresh your licenses ({status.error.message}). They keep working offline for {Math.max(0, days)} more day{days === 1 ? '' : 's'}.
        </div>
      </div>
    );
  }
  return null;
}
